import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/routes';
import type { DiagnosisUsage } from '@/types/productOptimization';

interface Props {
  usage: DiagnosisUsage | null;
}

const UsageBanner = ({ usage }: Props) => {
  const navigate = useNavigate();
  if (!usage) return null;

  const { usedCount, maxCount, isMembership } = usage;

  return (
    <div className="flex items-center gap-[16px]">
      <div className="flex items-center gap-[4px]">
        <span className="text-gr-900 Body1S16">월 진단 횟수</span>
        <span className="Body4S14">
          <span className="text-gr-900">{usedCount}</span>
          <span className="text-gr-500"> / {maxCount}</span>
        </span>
      </div>
      {!isMembership && (
        <button
          type="button"
          onClick={() => navigate(ROUTES.moreMembership)}
          className="cursor-pointer rounded-[8px] border-none bg-[#E6EFFF] px-[10px] py-[6px] text-statusBlue-400 Body5M14"
        >
          멤버십 가입하고 상품 진단하기
        </button>
      )}
    </div>
  );
};

export default UsageBanner;
